import { render, staticRenderFns } from "./viewCampania.vue?vue&type=template&id=670a8b4e&"
import script from "./viewCampania.vue?vue&type=script&lang=js&"
export * from "./viewCampania.vue?vue&type=script&lang=js&"
import style0 from "./viewCampania.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports